// extracted by mini-css-extract-plugin
export default {"productDetailHeader":"ProductHeader_productDetailHeader__LayvT","customIcon":"ProductHeader_customIcon__GNWtC"};